// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__AW-wv","label":"Radio_label__wbHJd","checkMark":"Radio_checkMark__BMITq","disabled":"Radio_disabled__1vA6k"};